export const STATE_CONFIG = {
  INVIATO: { label: 'RICEVUTO', class: 'state-inviato', color: 'yellow' },
  ASSEGNATO: { label: 'ASSEGNATO', class: 'state-blu', color: 'blue' },
  IN_LAVORAZIONE: { label: 'IN LAVORAZIONE', class: 'state-arancione', color: 'orange' },
  RISPOSTA_IN_BOZZA: { label: 'BOZZA', class: 'state-bozza', color: 'gray' },
  EVASO: { label: 'EVASO', class: 'state-verde', color: 'green' },
  ASSEVERATO: { label: 'ASSEVERATO', class: 'state-verde', color: 'green' },
  PUBBLICATO: { label: 'PUBBLICATO', class: 'state-verde', color: 'green' },
  'ASSEGNATO A UOC': { label: 'ASSEGNATO A UOC', class: 'state-verde', color: 'green' },
  NON_ASSEVERATO: { label: 'NON ASSEVERATO', class: 'state-rosso', color: 'red' },
  IN_ESAMINA_UOC: { label: 'IN ESAME UOC', class: 'state-info', color: 'info' },
  STORICO: { label: 'STORICO', class: 'state-dark', color: 'dark' }
};